import React from 'react';
import {Link} from 'react-router-dom';
import {A11y, Autoplay, EffectFade, Navigation, Pagination} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import Banner from '../uikit/Banner';
import 'swiper/css/a11y';
// import iran from '../../assets/images/iran.jpg';

export default function Ads() {
	return (
		/*<div className="mx-4">
		 <Link to="/network/31">
		 <Banner
		 title=""
		 image="https://files.novinrazavi.ir/competition/2db10db0-4948-430f-82dc-3fd8e77ba10f.jpg"
		 />
		 <Banner
		 title=""
		 image="https://files.novinrazavi.ir/competition/0db19c75-2ef9-42b4-8020-6591af2b2a58.gif"
		 />
		 <Banner
		 title=""
		 image="https://files.novinrazavi.ir/competition/3b688b94-d68f-4cb4-b3a3-16eaa9fc8386.jpg"
		 />
		 </Link>
		 </div>*/
		<>
			
			
			{/*
			<Swiper
				className="my-0 mx-4 swiper-ads"
				modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
				spaceBetween={10}
				effect={'fade'}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false
				}}
				slidesPerView={1}
				navigation={false}
				pagination={{
					clickable: true
					// 	type: 'progressbar'
				}}
				scrollbar={{draggable: true}}
				onSwiper={(swiper) => {
				}}
				onSlideChange={
					// () => console.log('slide change')
					() => {
					}
				}
			>
				<SwiperSlide key="1">
					<Link to="/ahd">
						<Banner
							title=""
							className="w-full"
							image="https://files.novinrazavi.ir/competition/ahd.webp"
						/>
					</Link>
				</SwiperSlide>
			</Swiper>
			*/}
			
			
			
			{/*			<Swiper
			 className="my-0 mx-4 swiper-ads"
			 modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
			 spaceBetween={10}
			 effect={'fade'}
			 autoplay={{
			 delay: 5000,
			 disableOnInteraction: false
			 }}
			 slidesPerView={1}
			 navigation={false}
			 pagination={{
			 clickable: true
			 // 	type: 'progressbar'
			 }}
			 scrollbar={{draggable: true}}
			 onSwiper={(swiper) => {
			 }}
			 onSlideChange={
			 // () => console.log('slide change')
			 () => {
			 }
			 }
			 >
			 <SwiperSlide key="1">
			 <a href="/competition/2"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 // image="https://files.novinrazavi.ir/competition/3546dd12-3bf5-4036-af7f-6e793ba52187.jpg"
			 image="https://files.novinrazavi.ir/competition/80432f9f-7b03-4378-ba09-aad54fbdd5ca.gif"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="1">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/6f782997-7018-494f-89e0-5a021ca7c6ad.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="1">
			 <a href="/competition/tekyehmajazi"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/tekye-baner.webp"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="2">
			 <a href="https://www.razavi.ir/fa/barandebash"
			 <a href="https://www.razavi.ir/barandebash"
			 <a href="https://haram.razavi.ir/quiz/116"
			 className="flex flex-col space-y-1 items-center text-center">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/najva.webp"
			 />
			 </a>
			 </SwiperSlide>
			 <SwiperSlide key="2">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/de726bbe-b79d-4722-b45a-f6153dbac5bd.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="3">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/37e9e4da-261a-4f15-999c-e04df54fb353.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="4">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/7e62ad04-396a-4c7b-b395-45d47d616f59.jpg"
			 />
			 </SwiperSlide>
			 <SwiperSlide key="5">
			 <Banner
			 title=""
			 className="w-full"
			 image="https://files.novinrazavi.ir/competition/a97842c0-1e21-4b43-91ce-f9c6aad049a9.jpg"
			 />
			 </SwiperSlide>
			 </Swiper>*/}
			{/*<Swiper
				className="my-0 mx-4 swiper-ads"
				modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
				spaceBetween={10}
				effect={'fade'}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false
				}}
				slidesPerView={1}
				navigation={false}
				pagination={{
					clickable: true
					// 	type: 'progressbar'
				}}
				scrollbar={{draggable: true}}
				onSwiper={(swiper) => {
				}}
				onSlideChange={
					// () => console.log('slide change')
					() => {
					}
				}
			>
				<SwiperSlide key="1">
					<Link to="/competition/imamreza">
						<Banner
							title=""
							className="w-full"
							image="https://files.novinrazavi.ir/rezvan/600.150.webp"
						/>
					</Link>
				</SwiperSlide>
			</Swiper>*/}
			{/*<Swiper
				className="my-0 mx-4 swiper-ads"
				modules={[EffectFade, Autoplay, Pagination, Navigation, A11y]}
				spaceBetween={10}
				effect={'fade'}
				autoplay={{
					delay: 5000,
					disableOnInteraction: false
				}}
				slidesPerView={1}
				navigation={false}
				pagination={{
					clickable: true
					// 	type: 'progressbar'
				}}
				scrollbar={{draggable: true}}
				onSwiper={(swiper) => {
				}}
				onSlideChange={
					// () => console.log('slide change')
					() => {
					}
				}
			>
				<SwiperSlide key="1">
					<Link to="/competition/muharram">
						<Banner
							title=""
							className="w-full"
							image="https://files.novinrazavi.ir/competition/banner-barande.webp"
						/>
					</Link>
				</SwiperSlide>
			</Swiper>*/}
		</>
	);
}
